import clsx from "clsx";
import style from "./Btn.module.css";
import { useCallback, useMemo } from "react";
import { IconType, useIcon } from "./useIcon";

export const Btn: React.FC<React.PropsWithChildren<{
    onClick: () => any,
    icon?: IconType
    area: string,
    disabled?: boolean,
    inverse?: boolean,
    primary?: boolean,
    square?: boolean,
    type?: "button" | "submit" | "reset"
}>> = ({ onClick, children, area, icon, type, ...props }) => {

    const classes = useMemo( () => clsx({
        [style.btn]: true,
        [style.primary]: props.primary,
        [style.inverse]: props.inverse,
        [style.disabled]: props.disabled,
        [style.square]: props.square,
        [style.hasIcon]: !!icon
    }), [props, icon] );

    const i = useIcon(icon)

    const clickHandler = useCallback( () => {

        if ( props.disabled ) {
            return;
        }

        onClick();

    }, [ onClick, props.disabled ] );

    return <button 
        type={type}
        className={classes} 
        onClick={clickHandler}
        style={{
            gridArea: area
        }}
    >{i}{children}</button>

}